import React from 'react';
import { motion } from 'framer-motion';
import { JaliDivider } from './JaliDivider';
import { useLanguage } from '../lib/LanguageContext';
export function WeddingEcosystem() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 bg-sandstone relative" id="partner" data-id="element-176">
      <JaliDivider className="absolute top-0 left-0" data-id="element-177" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-179">
          <span className="text-saffron tracking-widest uppercase text-sm font-medium mb-4 block" data-id="element-180">
            {t('weddingEcosystem.eyebrow')}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-8" data-id="element-181">
            {t('weddingEcosystem.title')}
          </h2>

          <div className="bg-marble p-8 md:p-12 rounded-sm border border-gold/20 shadow-sm mb-10" data-id="element-182">
            <p className="text-navy/80 text-lg leading-relaxed mb-8" data-id="element-183">
              {t('weddingEcosystem.description')}
            </p>
            <p className="text-navy/60 italic mb-8" data-id="element-184">
              {t('weddingEcosystem.plannerNote')}
            </p>

            <button className="px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-navy hover:text-ivory transition-colors duration-300" data-id="element-185">
              {t('weddingEcosystem.cta')}
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}